// page 404

import React from "react";
import "./notFound.css";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404</h1>
      <h2>Page non trouvée</h2>
      <Link to="/">Retourner à l'accueil</Link>
    </div>
  );
};

export default NotFound;
